const Footer = () => {
  return (
    <footer className="border-t border-border py-8 px-6 md:px-16">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="font-heading text-lg font-bold text-foreground">Urbanova</p>
        <p className="font-body text-xs text-muted-foreground">
          © {new Date().getFullYear()} Urbanova Apartments. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
